import React from 'react';
import { useConfig } from '../config/ConfigContext';
import SEOHead from '../components/SEOHead';

const AboutPage = () => {
  const { config } = useConfig();

  if (!config) return null;



  return (
    <div className="min-h-screen">
      <SEOHead
        title="About Us"
        description={`Learn more about ${config.branding.companyName} and our commitment to quality sleep solutions.`}
        canonical={`${window.location.origin}/about`}
      />

      {/* Hero Section with Blue Overlay */}
      <div className="relative h-[40vh] md:h-[350px]">
        <img
          src="/images/Bella/Product Photos/about us slider.jpg"
          alt="About Us"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-brand-blue/70" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            About <span className="font-script text-brand-red">Us</span>
          </h1>
        </div>
      </div>

      {/* Content Section 1 - Image Left, Text Right */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="order-2 md:order-1">
              <img
                src="/images/Bella/Product Photos/mission.jpg"
                alt="Our Mission"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
            </div>
            {/* Text */}
            <div className="order-1 md:order-2">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                <span className="font-script text-brand-red">Our</span> <span className="text-brand-blue">Mission</span>
              </h2>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                At {config.branding.companyName}, we believe that quality sleep is the foundation of a healthy, productive life.
                Our mission is to provide premium bedding solutions that transform your bedroom into a sanctuary of comfort and relaxation.
                Every product in our catalog is carefully selected to ensure the highest standards of quality, comfort, and durability.
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mt-4">
                We're committed to helping you find the perfect sleep solution that fits your lifestyle and budget,
                because everyone deserves a good night's sleep.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section 2 - Image Right, Text Left */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Text */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                <span className="font-script text-brand-red">Our</span> <span className="text-brand-blue">Vision</span>
              </h2>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                We envision a world where everyone has access to premium quality sleep products without compromise.
                Our carefully curated collection features mattresses, pillows, duvets, and bedding accessories designed
                with both comfort and style in mind.
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mt-4">
                Through our commitment to excellence and customer satisfaction, we strive to be your trusted partner
                in creating the perfect sleep environment. From fast delivery to responsive customer service,
                we're here to make your shopping experience exceptional.
              </p>
            </div>
            {/* Image */}
            <div>
              <img
                src="/images/Bella/Product Photos/vision.jpg"
                alt="Our Vision"
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-brand-blue to-blue-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Transform Your Sleep?
          </h2>
          <p className="text-xl mb-8 text-blue-100">
            Explore our collection of premium bedding solutions and find your perfect match.
          </p>
          <a
            href="/products"
            className="inline-block bg-white text-brand-blue px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors duration-300"
          >
            Shop Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
